module.exports = __webpack_public_path__ + "static/img/s-logo.b1777e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s-logo.png
// module id = pMqg
// module chunks = 22